/**
 * Prepare wrapper for togglers
 *
 * @type {HTMLDivElement}
 */
const togglerWrapper = document.createElement('div');
togglerWrapper.classList.add('ui-toggle');

const noErrorElsQuery = '[aria-hidden]:not(.error)';
const errorElsQuery = '.error[aria-hidden]';


/**
 * Setup conditional togglers
 */
export function setupConditionalTogglers() {
    document.body.appendChild(togglerWrapper);

    createConditionalToggler(noErrorElsQuery, 'fa-eye' , 'slash');
    createConditionalToggler(errorElsQuery, 'fa-bell' , 'slash');
}


/**
 * Create conditional togglers
 *
 * @param elsQuery
 * @param iconClass
 * @param iconModifierClass
 */
export function createConditionalToggler(elsQuery, iconClass, iconModifierClass) {
    const toggler = document.createElement('button');
    toggler.setAttribute('data-action', 'show');
    toggler.classList.add('ui-toggle__trigger', 'ui-toggle__trigger--base', 'far', `${iconClass}-${iconModifierClass}`);

    togglerWrapper.appendChild(toggler);

    toggler.addEventListener('click', () => toggle());
    toggler.addEventListener('keydown', () => toggle());

    function toggle() {
        const els = document.querySelectorAll(elsQuery);

        if (toggler.getAttribute('data-action') === 'show') {
            toggler.setAttribute('data-action', 'hide');
            conditionalToggler(true, els);
        } else {
            toggler.setAttribute('data-action', 'show');
            conditionalToggler(false, els);
        }

        toggler.classList.toggle(iconClass);
        toggler.classList.toggle(`${iconClass}-${iconModifierClass}`);
    }
}


/**
 * Conditional toggler
 *
 * @param show
 * @param els
 */
export function conditionalToggler(show, els) {
    for (let i = 0; i < els.length; i++) {
        if (show) {
            showEl(els[i]);
        } else {
            hideEl(els[i]);
        }
    }
}


/**
 * Conditional hide
 *
 * @param el
 */
export function hideEl(el) {
    el.setAttribute('aria-hidden', 'true');
    el.style.display = 'none';

    if (el.classList.contains('itemLevel')) {
        el.classList.remove('show');
    }
}


/**
 * Conditional show
 * @param el
 */
export function showEl(el) {
    el.setAttribute('aria-hidden', 'false');
    el.style.removeProperty('display');

    if (el.classList.contains('itemLevel')) {
        el.classList.add('show');
    }
}
